import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Toast, { ToastMessage } from './Toast';
import './Toast.css';

interface ToastContainerProps {
  messages: ToastMessage[];
  onRemove: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ messages, onRemove }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // 创建或获取容器
    let toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.id = 'toast-container';
      document.body.appendChild(toastContainer);
    }
    setContainer(toastContainer);

    return () => {
      // 清理容器
      if (toastContainer && toastContainer.parentNode && messages.length === 0) {
        toastContainer.parentNode.removeChild(toastContainer);
      }
    };
  }, [messages.length]);

  if (!container) return null;

  return ReactDOM.createPortal(
    <div className="toast-wrapper">
      {messages.map(message => (
        <Toast key={message.id} message={message} onClose={onRemove} />
      ))}
    </div>,
    container
  );
};

export default ToastContainer;